import fm from 'format-message';
import PropTypes from 'prop-types';
import { useStyletron } from '@activebrands/core-web/libs/styletron';
import CheckoutHeading from 'templates/CheckoutPage/CheckoutHeading';
import OrderTotal from 'templates/CheckoutPage/OrderTotal';
import BasketItems from 'templates/CheckoutPage/SummarySection/BasketItems';

const SummarySection = ({
    $style,
    bonusPointsInfo,
    bonusPointsPlaceholder,
    currentCheckoutStep,
    finalPrice,
    innerWrapperStyling,
    orderLabel,
    paymentStep,
    previewStateOverride,
    setCurrentCheckoutStep,
    shippingStep,
    voucherCodePlaceholder,
    voucherLabel,
}) => {
    const [css] = useStyletron();

    return (
        <div
            className={css({
                height: ['auto', null, null, null, null, '100%'],
                borderLeft: '1px solid var(--color-border-checkout-subtle)',
                ...$style,
            })}
        >
            <CheckoutHeading
                $textStyling={{ display: ['block', null, null, null, null, 'none'] }}
                editButtonVisible={currentCheckoutStep > shippingStep}
                fontKeys={['Misc/20_120_-025', null, null, null, null, 'Secondary/16_100_-02']}
                label={fm('Order summary')}
                text={finalPrice}
                onClickEdit={() => setCurrentCheckoutStep(shippingStep)}
            />
            <div
                className={css({
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: ['flex-start', null, null, null, null, 'space-between'],
                    height: ['auto', null, null, null, null, 'calc(100% - 65px)'], // Minus Checkout Heading height
                    borderBottom: '1px solid var(--color-border-checkout-subtle)',
                    ...innerWrapperStyling,
                })}
            >
                <BasketItems
                    previewStateOverride={previewStateOverride}
                    productCardType={currentCheckoutStep === paymentStep ? 'order' : 'basket'}
                />
                <OrderTotal
                    $style={{ borderTop: '1px solid var(--color-border-checkout-subtle)', marginTop: '-1px' }} // Hide borderink.
                    bonusPointsInfo={bonusPointsInfo}
                    bonusPointsPlaceholder={bonusPointsPlaceholder}
                    orderLabel={orderLabel}
                    showVouchersForm={currentCheckoutStep !== paymentStep}
                    voucherCodePlaceholder={voucherCodePlaceholder}
                    voucherLabel={voucherLabel}
                />
            </div>
        </div>
    );
};

SummarySection.propTypes = {
    $style: PropTypes.object,
    bonusPointsInfo: PropTypes.string,
    bonusPointsPlaceholder: PropTypes.string,
    currentCheckoutStep: PropTypes.number,
    finalPrice: PropTypes.string,
    innerWrapperStyling: PropTypes.object,
    orderLabel: PropTypes.string,
    paymentStep: PropTypes.number,
    previewStateOverride: PropTypes.object,
    setCurrentCheckoutStep: PropTypes.func,
    shippingStep: PropTypes.number,
    voucherCodePlaceholder: PropTypes.string,
    voucherLabel: PropTypes.string,
};

export default SummarySection;
